<template>
    <div v-loading="loading" class="mt-4">
        <div style="padding-left: 4px;" v-if="lastStatus === 10"
            class="d-flex justify-content-start align-items-center mb-3">
            <button type="button" class="btn btn-gradient-warning" @click="startProcess">
                <span class="btn-text">
                    <i class="fa fa-play me-1"></i> Qəbul et və başla
                </span>
            </button>
        </div>

        <div v-if="lastStatus > 10">
            <span style="background-color:#8E9A9B; color: white; padding:5px;">
                {{ "Məsul şəxs tərəfindən iş başlanmışdır: " + item.createdBy }}
            </span>
        </div>

        <div v-if="lastStatus > 10" class="card mt-4">
            <div class="card-body">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <titles text="Cavabdeh şəxslər" class="mb-0" />
                </div>
                <hr style="margin-top:0;" />
                <button type="button" class="btn bg-gradient-success mb-0" @click="createNewParticipant">
                    <i class="fa fa-plus me-1"></i> Yeni cavabdeh şəxs
                </button>
                <div v-if="responsiblePersons.length" class="row mt-3">
                    <div v-for="(person, index) in responsiblePersons" :key="index" class="col-md-6 mb-3">
                        <participant-card :person="person" :statusColor="person.statusColor" @edit="editParticipant"
                            @open-pre-court="openPreCourtDetails" />
                    </div>
                </div>
            </div>
        </div>

        <el-dialog v-model="openRespDialog" :title="isEditMode ? 'Cavabdeh düzəliş' : 'Yeni cavabdeh şəxs'"
            width="50%" top="70px">
            <div class="card-body pt-0">
                <div class="row">
                    <div class="d-flex align-items-center" style="width: 48%;">
                        <el-input v-if="personType === 1" v-model="pinSearch" size="large" placeholder="FİN daxil edin"
                            :disabled="!hasPin" clearable style="flex: 1;">
                            <template #prefix>
                                <div class="d-flex align-items-center"
                                    style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                    <el-switch v-model="hasPin" size="large" active-text="Rezident"
                                        inactive-text="Qeyri-rezident" inline-prompt
                                        style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                                </div>
                            </template>
                        </el-input>
                        <el-input v-if="personType === 2" v-model="voenSearch" size="large"
                            placeholder="VÖEN daxil edin" :disabled="!isLegalSearchActive" clearable style="flex: 1;">
                            <template #prefix>
                                <div class="d-flex align-items-center"
                                    style="border-right: 1px solid #dcdfe6; padding-right: 8px; margin-right: 8px;">
                                    <el-switch v-model="isLegalSearchActive" size="large" active-text="Rezident"
                                        inactive-text="Qeyri-rezident" inline-prompt
                                        style="--el-switch-on-color: #28a745; --el-switch-off-color: #dc3545;" />
                                </div>
                            </template>
                        </el-input>
                        <soft-button type="button" color="info" class="ms-2"
                            style="padding: 10px 16px; min-width: 48px;" :disabled="personType === 1 && !hasPin"
                            @click="searchRespPerson">
                            <i class="fa fa-search"></i>
                        </soft-button>
                    </div>  
                    <div class="col-md-12 mt-3">
                        <el-radio-group v-model="personType" size="large">
                            <el-radio :value="1">Fiziki şəxs</el-radio>
                            <el-radio :value="2">Hüquqi şəxs </el-radio>
                        </el-radio-group>
                    </div>            
                    <div v-if="personType === 1" class="row w-100">
                        <div class="col-md-6 mt-3">
                            <label class="form-label">FİN</label>
                            <el-input v-model="respForm.pin" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Cins</label>
                            <el-select v-model="respForm.gender" size="large" placeholder="Cins seçin"
                                style="width: 100%;" :disabled="hasPin">
                                <el-option label="Kişi" :value="1" />
                                <el-option label="Qadın" :value="2" />
                            </el-select>
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ad</label>
                            <el-input v-model="respForm.name" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlaqə nömrəsi</label>
                            <el-input v-model="respForm.mobilePhone" v-mask="'+994 (##) ###-##-##'" size="large"
                                placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Soyad</label>
                            <el-input v-model="respForm.surname" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlavə əlaqə nömrəsi</label>
                            <el-input v-model="respForm.additionalMobilePhone" v-mask="'+994 (##) ###-##-##'"
                                size="large" placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ata adı</label>
                            <el-input v-model="respForm.fatherName" size="large" :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">İş yeri</label>
                            <el-input v-model="respForm.workplace" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Doğum tarixi</label>
                            <el-date-picker v-model="respForm.dateOfBirth" size="large" placeholder="Tarix seçin"
                                type="date" format="DD.MM.YYYY" value-format="YYYY-MM-DD" style="width: 100%;"
                                :disabled="hasPin" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Faktiki yaşayış ünvanı</label>
                            <el-input v-model="respForm.regAddress" size="large" />
                        </div>
                    </div>

                    <div v-if="personType === 2" class="row w-100">
                        <div class="col-md-6 mt-3">
                            <label class="form-label">VÖEN</label>
                            <el-input v-model="respForm.tin" size="large" :disabled="isLegalSearchActive" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Faktiki yaşayış ünvanı</label>
                            <el-input v-model="respForm.regAddress" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Ad</label>
                            <el-input v-model="respForm.name" size="large" :disabled="isLegalSearchActive" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Mobil nömrə</label>
                            <el-input v-model="respForm.mobilePhone" size="large" placeholder="+994-(##)-123-45-66" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Nümayəndə</label>
                            <el-input v-model="respForm.representative" size="large" />
                        </div>
                        <div class="col-md-6 mt-3">
                            <label class="form-label">Əlavə nömrə</label>
                            <el-input v-model="respForm.additionalMobilePhone" size="large"
                                placeholder="+994-(##)-123-45-66" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row dialog-btn mt-4">
                <div class="d-flex justify-content-end">
                    <soft-button type="button" @click="saveRespPerson">
                        Yadda saxla
                    </soft-button>
                    &nbsp;
                    &nbsp;
                    <soft-button type="button" color="secondary" @click="openRespDialog = false">
                        İmtina
                    </soft-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import ParticipantCard from "../../Components/ParticipantCard.vue";
import SoftButton from "@/components/SoftButton.vue";
import { UpdateSubrogationStatus } from "@/project/Source/subrogations";
import { respPersonData } from "@/project/Source/helper";
import { CreateParticipant, UpdateParticipant, GetParticipants } from "@/project/Source/participants";
import Titles from "@/project/Components/Titles.vue";
import { GetAction } from "@/project/Source/actions";
import { mask } from "vue-the-mask";


export default {
    directives: {
        mask,
    },
    components: {
        SoftButton,
        ParticipantCard,
        Titles
    },
    props: {
        id: [String, Number],
        data: {
            type: Object,
            required: true
        },
        lastStatus: Number
    },
    data() {
        return {
            loading: false,
            uid: this.$store.state.user.id,
            item: { ...this.data },
            openRespDialog: false,
            hasPin: true,
            isLegalSearchActive: true,
            pinSearch: "",
            voenSearch: "",
            personType: 1, //fiziki şəxs
            isEditMode: false,
            editParticipantId: null,
            responsiblePersons: [],
            respForm: {
                pin: "",
                name: "",
                surname: "",
                fatherName: "",
                mobilePhone: "",
                additionalMobilePhone: "",
                gender: null,
                dateOfBirth: "",
                regAddress: "",
                workplace: "",
                tin: "",
                representative: ""
            }
        };
    },
    watch: {
        data: {
            immediate: true,
            handler(newVal) {
                this.selectedAgreementType = newVal.consentType || null;
                this.item = { ...newVal };
            }
        }
    },
    mounted() {
        this.loadParticipants();
    },
    methods: {
        createNewParticipant() {
            this.resetRespForm();
            this.openRespDialog = true;
        }
        ,
        openPreCourtDetails(person) {
            const subrogationId = this.id;
            const participantId = person.id;

            this.$router.push({
                name: "SubrogationPreCourtDetails",
                params: {
                    subrogationId,
                    participantId
                }
            });
        },
        async loadParticipants() {
            this.loading = true;
            try {
                const response = await GetParticipants(this.id);
                let participants = response.data.data || [];

                for (const person of participants) {
                    try {
                        const res = await GetAction(person.id);
                        const action = res.data.data[0];

                        person.statusColor = this.getStatusColor(action);
                    } catch {
                        person.statusColor = null;
                    }
                }

                this.responsiblePersons = participants;
            } catch (err) {
                console.error("Error loading participants:", err);
                this.$message.error("Cavabdeh şəxsləri yükləmək mümkün olmadı");
            } finally {
                this.loading = false;
            }
        },
        getStatusColor(action) {
            if (action?.actionType === 1 && action?.actionReason === 1) {
                return "green";
            } else if (action?.actionType === 1 && action?.actionReason === 0) {
                return "red";
            }
            return "orange";
        },



        async startProcess() {
            const result = await this.$swal({
                title: "Təsdiq edin",
                text: "Başlamaq istədiyinizə əminsiniz?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "İmtina",
                confirmButtonText: "Təsdiq et",
                customClass: {
                    confirmButton: "btn bg-gradient-info",
                    cancelButton: "btn bg-gradient-secondary",
                },
                buttonsStyling: false,
            });

            if (result.isConfirmed) {
                this.loading = true;
                try {
                    const data = {
                        id: this.id,
                        commandUserId: this.uid
                    };
                    await UpdateSubrogationStatus(data);
                    this.$message.success("Uğurlu əməliyyat");
                    this.$emit("status-updated");
                } catch (error) {
                    console.error("Failed to update status:", error);
                    this.$message.error("Xəta baş verdi");
                } finally {
                    this.loading = false;
                }
            }
        },
        searchRespPerson() {
            if (this.personType === 1) {
                const match = respPersonData.find(p => p.pin === this.pinSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.pinSearch = "";
                } else {
                    this.$message.warning("FİN tapılmadı");
                }
            } else if (this.personType === 2) {
                const match = respPersonData.find(p => p.tin === this.voenSearch);
                if (match) {
                    this.respForm = { ...match };
                    this.voenSearch = "";
                } else {
                    this.$message.warning("VÖEN tapılmadı");
                }
            }
        },
        saveRespPerson() {
            this.loading = true;

            let payload;

            if (this.personType === 1) {
                payload = {
                    subrogationId: this.id,
                    name: this.respForm.name,
                    surname: this.respForm.surname,
                    fatherName: this.respForm.fatherName,
                    pin: this.respForm.pin,
                    personType: 1,
                    gender: this.respForm.gender,
                    birthDate: this.respForm.dateOfBirth,
                    phone: this.respForm.mobilePhone,
                    additionalPhone: this.respForm.additionalMobilePhone,
                    workPlace: this.respForm.workplace,
                    regAddress: this.respForm.regAddress
                };
                if (this.isEditMode) {
                    payload.id = this.editParticipantId;
                }
            } else {
                payload = {
                    subrogationId: this.id,
                    name: this.respForm.name,
                    pin: this.respForm.pin,
                    tin: this.respForm.tin,
                    personType: 2,
                    phone: this.respForm.mobilePhone,
                    additionalPhone: this.respForm.additionalMobilePhone,
                    regAddress: this.respForm.regAddress,
                    representative: this.respForm.representative
                };
                if (this.isEditMode) {
                    payload.id = this.editParticipantId;
                }
            }

            const action = this.isEditMode ? UpdateParticipant : CreateParticipant;

            action(payload)
                .then(() => {
                    this.$message.success("Uğurlu əməliyyat!");
                    this.loadParticipants();
                    this.openRespDialog = false;
                    this.resetRespForm();
                })
                .catch((error) => {
                    this.$message.error("Xəta baş verdi.");
                    console.error("Participant save error:", error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        editParticipant(person) {
            this.respForm = {
                pin: person.pin || "",
                name: person.name || "",
                surname: person.surname || "",
                fatherName: person.fatherName || "",
                mobilePhone: person.phone || "",
                additionalMobilePhone: person.additionalPhone || "",
                gender: person.gender || "",
                dateOfBirth: person.birthDate || "",
                regAddress: person.regAddress || "",
                workplace: person.workPlace || "",
                tin: person.tin || "",
                representative: person.representative || ""
            };
            this.personType = person.personType;
            this.editParticipantId = person.id;
            this.isEditMode = true;
            this.openRespDialog = true;
        },
        resetRespForm() {
            this.respForm = {
                pin: "",
                name: "",
                surname: "",
                fatherName: "",
                mobilePhone: "",
                additionalMobilePhone: "",
                gender: "",
                dateOfBirth: "",
                regAddress: "",
                workplace: "",
                tin: "",
                representative: ""

            };
            this.pinSearch = "";
            this.personType = 1;
            this.hasPin = true;
            this.isEditMode = false;
            this.editParticipantId = null;
        },
    }
};
</script>

<style scoped></style>